import BotRecaptcha from "./bot-recaptcha";
import Map from "./maps";
import React, { memo } from "react";
import MapPlaceholder from "./map-placeholder";

interface MapContainerProps {
  googleLoaded: boolean;
  isBot: boolean;
  setIsBot: Function;
  hideMap?: boolean;
}

const MapContainer = (props: MapContainerProps) => {
  return (
    <div
      sx={{
        flexGrow: 1,
        width: "auto",
        height: "auto",
        overflow: "hidden",
        position: "relative",
        "&:before": {
          content: '""',
          position: "absolute",
          boxShadow: [
            "inset 0px 2px 5px rgba(0, 0, 0, 0.1), inset 0px -2px 5px rgba(0, 0, 0, 0.1)",
            "inset 0px 2px 5px rgba(0, 0, 0, 0.1), inset 0px -2px 5px rgba(0, 0, 0, 0.1)",
            "inset 0px 2px 5px rgba(0, 0, 0, 0.1), inset 0px -2px 5px rgba(0, 0, 0, 0.1)",
            "none",
          ],
          zIndex: 1,
          overflow: "hidden",
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          width: "100%",
          pointerEvents: "none",
        },
      }}
    >
      {props.googleLoaded ? (
        <Map hideMap={props.hideMap} />
      ) : props.isBot ? (
        <BotRecaptcha onChange={() => props.setIsBot(false)} />
      ) : null}
    </div>
  );
};

export default memo(MapContainer);
